import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type FilterGroupState, type SalesFilters } from '../types';

const updateSalesFiltersCase: CaseReducer<
  FilterGroupState,
  PayloadAction<Partial<SalesFilters>>
> = (state, action) => {
  state.sales = {
    ...state.sales,
    ...action.payload,
  };

  return state;
};

export { updateSalesFiltersCase };
